import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TalkToDoctorService } from '../api-services/talk-to-doctor.service';
import {
  endOfDay,
  addMonths,
  format,
  startOfHour,
  addHours,
  addMinutes,
  startOfMinute,
  parseISO,
} from 'date-fns';
import {
  DAYS_IN_WEEK,
  SchedulerViewDay,
  SchedulerViewHour,
  SchedulerViewHourSegment,
  CalendarSchedulerEvent,
  CalendarSchedulerEventAction,
  startOfPeriod,
  endOfPeriod,
  addPeriod,
  subPeriod,
  SchedulerDateFormatter,
  SchedulerEventTimesChangedEvent,
  CalendarSchedulerViewComponent,
} from 'angular-calendar-scheduler';
import {
  CalendarView,
  CalendarDateFormatter,
  DateAdapter,
} from 'angular-calendar';
import { Subject } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
/**
 * This component can show doctor appointments list and categorize appointments
 * like upcoming, reject,cancel and all appointment tabs.
 * Doctor can do action as accept, reject or reschedule the appointments.
 * For reschedule the appointment using angular-calendar-schedular.
 * This component is simlar functional flow as a member appointment component.
 */
@Component({
  selector: 'app-doctor-appointment',
  templateUrl: './doctor-appointment.component.html',
  styleUrls: ['./doctor-appointment.component.css'],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: SchedulerDateFormatter,
    },
  ],
})
export class DoctorAppointmentComponent implements OnInit {
  doctorObj: any;
  appoint_List: any;
  loader: boolean;
  selectId: any;
  selectName: any;
  reason_text: any;
  appointmentTime: any;
  todayDate = new Date();
  date: any = new Date();
  fromDate: any;
  startAt: Date;
  endAt: Date;
  p: any;
  reqObj = new FormGroup({
    number: new FormControl(0),
    size: new FormControl(5),
    fromDate: new FormControl('', Validators.required),
    endDate: new FormControl('', Validators.required),
  });
  isRangeDates: boolean;
  appTypeString: string;
  copySelect_fromDate = '';
  copySelect_endDate = '';

  //Event Calendar
  CalendarView = CalendarView;
  view: CalendarView = CalendarView.Week;
  viewDate: Date = new Date();
  viewDays: number = 7;
  refresh: Subject<any> = new Subject();
  locale: string = 'en';
  hourSegments: number = 2;
  weekStartsOn: number = 1;
  startsWithToday: boolean = true;
  activeDayIsOpen: boolean = true;
  excludeDays: number[] = []; // [0];
  dayStartHour: number = 0;
  dayEndHour: number = 24;
  minDate: Date = new Date();
  maxDate: Date = endOfDay(addMonths(new Date(), 2));
  dayModifier: Function;
  hourModifier: Function;
  segmentModifier: Function;
  eventModifier: Function;
  prevBtnDisabled: boolean = false;
  nextBtnDisabled: boolean = false;
  count = 0;

  events: CalendarSchedulerEvent[] = [];

  @ViewChild(CalendarSchedulerViewComponent)
  calendarScheduler: CalendarSchedulerViewComponent;
  actions: CalendarSchedulerEventAction[] = [
    {
      when: 'enabled',
      label:
        '<span class="valign-center"><i class="bi bi-x-circle-fill  iconClr"></i>Delete</span>',
      title: 'Delete',
      onClick: (event: CalendarSchedulerEvent): void => {
        this.events = this.events.filter((item) => item.title !== event.title);
        this.count = 0;
        this.refresh.next();
        this.appointmentTime = '';
      },
    },
    {
      when: 'cancelled',
      label:
        '<span class="valign-center"><i class="material-icons md-18 md-red-500">autorenew</i></span>',
      title: 'Restore',
      onClick: (event: CalendarSchedulerEvent): void => {
        // console.log("Pressed action 'Restore' on event " + event.id);
      },
    },
  ];

  constructor(
    private doctorservice: TalkToDoctorService,
    private router: Router,
    private dateAdapter: DateAdapter,
    public modalService: BsModalService
  ) {
    this.dayModifier = ((day: SchedulerViewDay): void => {
      day.cssClass = this.isDateValid(day.date) ? '' : 'cal-disabled';
    }).bind(this);
    this.segmentModifier = ((segment: SchedulerViewHourSegment): void => {
      segment.isDisabled = !this.isDateValid(segment.date);
    }).bind(this);

    this.eventModifier = ((event: CalendarSchedulerEvent): void => {
      event.isDisabled = !this.isDateValid(event.start);
    }).bind(this);

    this.dateOrViewChanged();
  }

  ngOnInit(): void {
    this.appTypeString = 'all';

    jQuery('.dropdown-toggle').on('click', function (e) {
      $(this).next().toggle('fast');
    });
    this.date = format(this.todayDate, 'dd/MM/yyyy');

    const roundToHalf = (date) =>
      new Date(Math.ceil(date / (1000 * 60 * 30)) * (1000 * 60 * 30));
    this.todayDate = roundToHalf(new Date());
    this.startAt = new Date(new Date().setHours(6, 0, 0));
    this.endAt = new Date(new Date().setHours(22, 0, 0));
    this.startAt >= this.todayDate
      ? (this.todayDate = this.startAt)
      : (this.startAt = this.todayDate);
    this.appointmentsList();
    this.getSchedular(this.viewDate);
  }

  async getSchedular(date) {
    this.events = [];
    let finalDate = new Date().setDate(date.getDate() + 6);
    let obj = {
      fromDate: format(date, 'dd-MM-yyyy'),
      endDate: format(finalDate, 'dd-MM-yyyy'),
      doctorId: 0,
    };
    this.doctorservice.DoctorBookingScheduler(obj).subscribe(async (data) => {
      let getdata: any = data;
      this.dayEndHour = getdata.availabilityEndTime;
      this.dayStartHour = getdata.availabilityStartTime;
      this.refresh.next();
      await getdata.calenderEvents.forEach((ele) => {
        let eventData: CalendarSchedulerEvent = {
          id: ele.id,
          start: startOfMinute(new Date(ele.start)),
          //end: addMinutes(startOfHour(addHours(new Date(1628506217195), 0)), 29),
          end: addMinutes(startOfMinute(new Date(ele.end)), ele.interval),
          title: ele.title,
          content: ele.content,
          color: ele.color,
          actions: this.actions,
          // status: 'ok' as CalendarSchedulerEventStatus,
          isClickable: ele.clickable,
          isDisabled: ele.disabled,
        };
        this.events.push(eventData);
      });
      this.refresh.next();
    });
  }

  openModal(temp) {
    this.modalService.show(temp, {
      class: 'mymodal',
    });
  }

  getappName(apptype) {
    this.reqObj.get('number').patchValue(0);
    this.reqObj.get('size').patchValue(5);
    this.reqObj.get('fromDate').patchValue('');
    this.reqObj.get('endDate').patchValue('');
    this.copySelect_fromDate = '';
    this.copySelect_endDate = '';
    this.reqObj.markAsUntouched();
    $('.dropdown-menu').hide();
    this.appTypeString = apptype;
    if (apptype === 'all') {
      this.appointmentsList();
    } else if (apptype === 'upcoming') {
      this.getupcomingAppList();
    } else if (apptype === 'reject') {
      this.getRejectAppList();
    } else if (apptype === 'cancel') {
      this.getCancelAppList();
    }
  }
  appointmentDates(str: string) {
    this.copySelect_fromDate = this.reqObj.get('fromDate').value;
    this.copySelect_endDate = this.reqObj.get('endDate').value;
    let frmDate = new Date(this.reqObj.get('fromDate').value).getTime();
    let toDate = new Date(this.reqObj.get('endDate').value).getTime();
    this.reqObj
      .get('endDate')
      .patchValue(format(this.reqObj.get('endDate').value, 'dd-MM-yyyy'));
    this.reqObj
      .get('fromDate')
      .patchValue(format(this.reqObj.get('fromDate').value, 'dd-MM-yyyy'));
    this.reqObj.get('number').patchValue(0);
    if (!(toDate > frmDate)) {
      return (this.isRangeDates = true);
    } else {
      $('.dropdown-menu').hide();
      if (str == 'all') {
        this.appointmentsList();
      } else if (str == 'upcoming') {
        this.getupcomingAppList();
      } else if (str == 'reject') {
        this.getRejectAppList();
      } else if (str == 'cancel') {
        this.getCancelAppList();
      }
    }
  }
  appointmentsList() {
    this.loader = false;
    this.doctorservice.DoctorsAppoint_lists(this.reqObj.value).subscribe(
      (data: any) => {
        data.content.forEach((ele) => {
          if (ele.appointmentTime != 'null') {
            ele.appointmentDate = format(
              parseISO(ele.appointmentTime),
              'dd/MM/yyyy'
            );
            return ele;
          }
        });
        this.appoint_List = data;
        this.p = this.appoint_List.number + 1;
        this.selectedDates();
        this.loader = true;
      },
      (err) => {}
    );
  }

  getupcomingAppList() {
    this.doctorservice.upcomingDocAppList(this.reqObj.value).subscribe(
      (data: any) => {
        data.content.forEach((ele) => {
          if (ele.appointmentTime != 'null') {
            ele.appointmentDate = format(
              parseISO(ele.appointmentTime),
              'dd/MM/yyyy'
            );
            return ele;
          }
        });
        this.appoint_List = data;
        this.p = this.appoint_List.number + 1;
        this.selectedDates();
        this.isRangeDates = false;
      },
      (err) => {}
    );
  }
  getCancelAppList() {
    this.doctorservice.cancalDocAppList(this.reqObj.value).subscribe(
      (data: any) => {
        data.content.forEach((ele) => {
          if (ele.appointmentTime != 'null') {
            ele.appointmentDate = format(
              parseISO(ele.appointmentTime),
              'dd/MM/yyyy'
            );
            return ele;
          }
        });
        this.appoint_List = data;
        this.p = this.appoint_List.number + 1;
        this.isRangeDates = false;
        this.selectedDates();
      },
      (err) => {}
    );
  }

  getRejectAppList() {
    this.doctorservice.rejectDocAppList(this.reqObj.value).subscribe(
      (data: any) => {
        data.content.forEach((ele) => {
          if (ele.appointmentTime != 'null') {
            ele.appointmentDate = format(
              parseISO(ele.appointmentTime),
              'dd/MM/yyyy'
            );
            return ele;
          }
        });
        this.appoint_List = data;
        this.p = this.appoint_List.number + 1;
        this.isRangeDates = false;
        this.selectedDates();
      },
      (err) => {}
    );
  }

  getPagination(pageNum: any, str: string) {
    if (this.reqObj.get('fromDate').value && this.reqObj.get('endDate').value) {
      this.reqObj
        .get('endDate')
        .patchValue(format(this.reqObj.get('endDate').value, 'dd-MM-yyyy'));
      this.reqObj
        .get('fromDate')
        .patchValue(format(this.reqObj.get('fromDate').value, 'dd-MM-yyyy'));
    }
    this.reqObj.get('number').patchValue(pageNum - 1);
    if (str == 'all') {
      this.appointmentsList();
    } else if (str == 'upcoming') {
      this.getupcomingAppList();
    } else if (str == 'reject') {
      this.getRejectAppList();
    } else if (str == 'cancel') {
      this.getCancelAppList();
    }
  }

  async appointStatus(id, P_name?: string, str?: string) {
    let data: any;
    if (str == 'SCHEDULED') {
      data = {
        appointmetId: id,
        reason: 'accepted',
        status: 'SCHEDULED',
      };
      this.doctorservice.doctorApprove(data).subscribe((data) => {
        if (data) {
          this.appointmentsList();
        }
      });
    } else {
      (this.selectId = id), (this.selectName = P_name);
    }
  }

  joinMeeting(id) {
    this.loader = false;
    this.doctorservice.DoctorJoinVideo(id).subscribe((data) => {
      let getData: any = data;
      if (getData.result) {
        this.loader = true;
        let roomname = getData.roomName;
        let username = getData.membername;
        let participant = getData.participant;
        this.router.navigate(['/conference-room'], {
          queryParams: {
            room: roomname,
            joiner: username,
            participant: participant,
            id: id,
          },
        });
      }
    });
  }

  reqForReject(id, reason, str) {
    if (str == 'reject') {
      const data = {
        appointmetId: id,
        reason: reason,
        status: 'REJECTED',
      };
      this.doctorservice.doctorApprove(data).subscribe((data) => {
        if (data) {
          this.reason_text = '';
          this.appointmentsList();
        }
      });
    }
  }

  reqForReschedule(id, appTime) {
    const data = {
      appointmetId: id,
      appointmentDate: appTime,
      appointmentTime: appTime,
    };
    this.doctorservice.rescheduleAppointment(data).subscribe((data) => {
      if (data) {
        this.appointmentTime = '';
        this.appointmentsList();
      }
    });
  }

  selectedDates() {
    if (this.copySelect_fromDate && this.copySelect_endDate) {
      this.reqObj.get('endDate').patchValue(this.copySelect_endDate);
      this.reqObj.get('fromDate').patchValue(this.copySelect_fromDate);
    } else {
      this.reqObj.get('endDate').patchValue('');
      this.reqObj.get('fromDate').patchValue('');
    }
  }

  //Events

  viewDaysOptionChanged(viewDays: number): void {
    this.calendarScheduler.setViewDays(viewDays);
  }

  changeDate(date: Date): void {
    this.viewDate = date;
    this.dateOrViewChanged();
  }

  changeView(view: CalendarView): void {
    this.view = view;
    this.dateOrViewChanged();
  }

  dateOrViewChanged(): void {
    if (this.startsWithToday) {
      this.prevBtnDisabled = !this.isDateValid(
        subPeriod(
          this.dateAdapter,
          CalendarView.Day /*this.view*/,
          this.viewDate,
          1
        )
      );
      this.nextBtnDisabled = !this.isDateValid(
        addPeriod(
          this.dateAdapter,
          CalendarView.Day /*this.view*/,
          this.viewDate,
          1
        )
      );
    } else {
      this.prevBtnDisabled = !this.isDateValid(
        endOfPeriod(
          this.dateAdapter,
          CalendarView.Day /*this.view*/,
          subPeriod(
            this.dateAdapter,
            CalendarView.Day /*this.view*/,
            this.viewDate,
            1
          )
        )
      );
      this.nextBtnDisabled = !this.isDateValid(
        startOfPeriod(
          this.dateAdapter,
          CalendarView.Day /*this.view*/,
          addPeriod(
            this.dateAdapter,
            CalendarView.Day /*this.view*/,
            this.viewDate,
            1
          )
        )
      );
    }

    if (this.viewDate < this.minDate) {
      this.changeDate(this.minDate);
    } else if (this.viewDate > this.maxDate) {
      this.changeDate(this.maxDate);
    }
  }

  private isDateValid(date: Date): boolean {
    return date >= this.minDate && date <= this.maxDate;
  }

  viewDaysChanged(viewDays: number): void {
    this.viewDays = viewDays;
  }

  dayHeaderClicked(day: SchedulerViewDay): void {
    // console.log('dayHeaderClicked Day', day);
  }

  segmentClicked(action: string, segment: SchedulerViewHourSegment): void {
    this.count++;
    if (this.count == 1) {
      this.appointmentTime = segment.date;
      // this.requestForm.get('appointmentDate').patchValue(segment.date);
      segment.backgroundColor = '#e8fde7';
      segment.isDisabled = true;
      let eventData: CalendarSchedulerEvent = {
        id: '',
        start: startOfMinute(new Date(segment.date)),
        color: { primary: '#e8fde7', secondary: '#e8fde7' },
        title: '',
        actions: this.actions,
        isClickable: true,
      };
      this.events.push(eventData);
      this.refresh.next();
      this.modalService.hide();
    }
  }

  eventClicked(action: string, event: CalendarSchedulerEvent): void {
    // console.log('eventClicked Action', action);
    // console.log('eventClicked Event', event);
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
    type,
  }: SchedulerEventTimesChangedEvent): void {
    const ev: CalendarSchedulerEvent = this.events.find(
      (e) => e.id === event.id
    );
    ev.start = newStart;
    ev.end = newEnd;
    this.refresh.next();
  }
}
